import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { DisplayManageVehiclesComponent } from "./display-manage-vehicles.component";
import { FilterModule } from "app/shared/filter/filter.module";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { ActionsModule } from "../../../shared/actions/actions.module";
import { NgbDatepickerModule } from "@ng-bootstrap/ng-bootstrap";
import { BusyModule } from "app/busy/busy.module";

@NgModule({
  declarations: [DisplayManageVehiclesComponent],
  exports: [DisplayManageVehiclesComponent],
  imports: [
    CommonModule,
    FilterModule,
    FormsModule,
    ReactiveFormsModule,
    ActionsModule,
    NgbDatepickerModule,
  ],
})
export class DisplayManageVehiclesModule {}
